import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { RoutePath } from '../utils';

export interface INavigationService {
  currentPath: string;
  setCurrentPath: (currentPath: string) => void;
  getCurrentPath: () => string;
  isKnowledgeBlockContentReady: () => boolean;
}

class NavigationServiceImpl implements INavigationService {
  @observable public currentPath: string = null;

  setCurrentPath(currentPath: string) {
    this.currentPath = currentPath;
  }

  getCurrentPath() {
    return this.currentPath;
  }

  // Temp function to only show knowledge blocks button if content is ready
  // For now, the knowledge block is only available on the market depth page
  isKnowledgeBlockContentReady() {
    return (
      this.currentPath === RoutePath.MARKET_DEPTH ||
      this.currentPath === RoutePath.EXECUTION ||
      this.currentPath === RoutePath.BUYER_DASHBOARD ||
      this.currentPath === RoutePath.SELLER_DASHBOARD
    );
  }
}

export const INavigationService = DI.createInterface<INavigationService>((x) =>
  x.singleton(NavigationServiceImpl),
);
